module.exports = {
  pageTitle: 'Réinitialisation du mot de passe',
  emailTitle: "Merci d'entrer votre email, un lien vers le formulaire de changement de mot de passe vous sera envoyé.",
  formTitle: 'Entrez votre nouveau mot de passe',
  email: {
    label: 'Email',
  },
  ask: {
    successMessage: 'Un email contenant un lien pour réinitialiser votre mot de passe vous a été envoyé.',
    errorMessage: 'Une erreur est survenue, merci de réessayer dans quelques instants.',
  },
  password: {
    label: 'Mot de passe',
  },
  passwordConfirm: {
    label: 'Confirmation',
  },
  submit: {
    loading: 'Enregistrement...',
    changePassword: 'Envoyer',
  },
  successMessage:
    'Votre nouveau mot de passe a bien été enregistré. Vous pouvez desormais vous connecter sur <a href="/" target="_self">FishFriender.com</a>',
  unknownError: 'Une erreur est survenue, merci de réessayer dans quelques instants.',
}
